import api from '@/api'
import Multiselect from 'vue-multiselect'
import { mapGetters } from 'vuex'
import chatbox from './livechat-chatbox'
import LivechatChattool from './livechat-chattool'
import users from './LivechatUsers/LivechatUsers2'

import LivechatPagelist from './livechat-pagelist'
import LivechatSearch from './LivechatSearch'
import LivechatSearchBox from './LivechatSearchBox'
import LivechatTab from './LivechatTab'

import LivechatSocialChannelMixin from './LivechatSocialChannelMixin'
export default {
  mixins: [LivechatSocialChannelMixin],
  props: {
    isMobile: { default: false }
  },
  components: {
    chatbox: chatbox,
    users: users,
    Multiselect,
    LivechatChattool,
    LivechatPagelist,
    LivechatSearch,
    LivechatSearchBox,
    LivechatTab
  },
  data() {
    return {
      app: '',
      timer: '',
      type: 'bot',
      allrentcustomer: [],
      allrentsupplier: [],
      usersearching: false,
      toolListHeight: 0,
      showSearch: false,
      openStartDate: false,
      openStartTime: false,
      openEndDate: false,
      openEndTime: false,
      input: {
        uuAreaName: '',
        search: '',
        uu_register_status: '',
        lastconversationfromdate: null,
        lastconversationtodate: null,
        lastconversationfromtime: null,
        lastconversationtotime: null,
        lastconversationfrom: null,
        lastconversationto: null,
        phoneno: null,
        uu_name: null,
        keyword: '',
        tags: [],
        status: null,
        app: '',
        session: '',
        assignadminname: ''
      },
      loading: false,
      selectedUser2: null
    }
  },
  async created() {
    var vm = this

    if (vm.$store.state.livechat.filter.search) {
      vm.$store.state.livechat.filter.search = ''
    }

    if (vm.$route.query.user) {
      this.$store.commit('SET_LIVECHAT_TYPE', vm.$route.query.user == 'bot' ? 'bot' : 'admin')
    }
    if (vm.$route.query.userid) {
      var userid = vm.$route.query.userid

      if (userid) {
        const user_response = await vm.getUsersdata(userid)
        if (user_response) {
          vm.selectedUser = {
            ...user_response,
            lastreply_time: null,
            session: '',
            userid: user_response.id,
            uu_areaname: null,
            type: user_response.context == 'contactadmin' ? 'admin' : ''
          }

          vm.$store.commit('SET_LIVECHAT_USER', vm.selectedUser)
          if (vm.isMobile) {
            await vm.$nextTick()
            vm.view = 'chatbox'
          }
        } else {
          vm.$swal({
            type: 'info',
            title: 'Not found this user'
          })
        }
      }
    }

    if (
      this.selectedBot.theme == 'ticket' ||
      this.$store.state.ticketThemeList.includes(this.selectedBot.theme) ||
      this.$store.state.ticketPageid.includes(this.selectedBot.pageid)
    ) {
      this.$store.dispatch('loadAgents')
      this.$store.dispatch('loadAgentGroups')
      this.$store.dispatch('loadAgentSubGroups')
    }
    vm.$store.dispatch('livechatnotiunread').then((val) => {
      if (
        val &&
        document.getElementById('noti_sound') &&
        !JSON.parse(localStorage.getItem('muteChat'))
      )
        document.getElementById('noti_sound').play()
    })

    let refreshNotiunread = ['102052945584054', '106855151601601'].includes(vm.livechat.pageid)
      ? 30000
      : vm.$store.getters.getLivechatDetail('maxFetchReadTime')
    vm.timer = setInterval(() => {
      vm.$store.dispatch('livechatnotiunread').then((val) => {
        if (
          val &&
          document.getElementById('noti_sound') &&
          !JSON.parse(localStorage.getItem('muteChat'))
        )
          document.getElementById('noti_sound').play()
      })
    }, refreshNotiunread)

    if ([...this.$store.state.bbqPage].includes(this.selectedBot.pageid)) {
      await this.handleBbqFetchAllStatusColor()
    }
  },
  beforeDestroy: function () {
    clearInterval(this.timer)
  },
  mounted: function () {
    if (
      this.$route.query.app &&
      this.livechatChannelOptions.some((social) => social.fullValue == this.$route.query.app)
    ) {
      this.$store.commit('SET_LIVECHAT_APP', this.$route.query.app)
    } else {
      this.$store.commit('SET_LIVECHAT_APP', this.livechatChannelOptions[0].fullValue)
    }
    this.$store.commit(
      'SET_LIVECHAT_TYPE',
      this.$route.query.user && ['bot', 'admin'].includes(this.$route.query.user)
        ? this.$route.query.user
        : 'admin'
    )
    if (this.$route.query.pageid) {
      this.$store.state.livechat.pageid = this.$route.query.pageid
      this.$store.state.selectedBot.pageid = this.$route.query.pageid
    }

    if (!this.$store.state.chatConfig) {
      this.$store.dispatch('getChatConfig')
    }
  },
  computed: {
    newchatnotify() {
      return this.$store.state.newchatnotify
    },
    isUnlock() {
      var bot = this.botlist.find((el) => {
        return el.pageid == this.$store.state.livechat.pageid
      })
      if (!bot) return false
      return (
        (bot.pagetype == 'enterprise' && this.$store.state.livechatPageList.includes(bot.theme)) ||
        this.$store.state.livechatPageIdList.includes(bot.pageid) ||
        (bot.theme == 'ecommercebasic' && bot.pageid == '270028443161479') ||
        bot.isUnlockLivechat ||
        bot.unlock_livechat
      )
    },

    ...mapGetters({
      selectedBot: 'selectedBot',
      botlist: 'botlist',
      searchlist: 'getLivechatSearching',
      astonAdmins: 'getAstonAdmins',
      loadingAstonAdmin: 'getLoadingAstonAdmins',
      livechat: 'livechat'
    }),
    computedAstonAdmins() {
      if (this.$aston.astonpages.includes(this.$store.state.livechat.pageid)) {
        if (this.astonAdmins) {
          var admins = this.astonAdmins.map((el) => {
            return {
              text: el.name,
              value: el.name
            }
          })
          admins.unshift({ text: 'ยังไม่ได้ Assign', value: '' })
          return admins
        } else {
          return []
        }
      } else {
        return []
      }
    },

    selectedUser: {
      get() {
        return this.$store.state.livechat.currentUser
      },
      set(newVal) {
        this.$store.state.livechat.currentUser = newVal
      }
    },
    filter: {
      get() {
        return this.$store.state.filter
      },
      set(val) {
        this.$store.state.filter = val
      }
    },
    areaname: function () {
      var area = this.$store.state.uuAreaName
      area.unshift('')
      return area
    }
  },
  methods: {
    handleReloadUser() {
      this.$store.dispatch('loadLatestUsers', {
        type: this.type
      })
    },
    handleChangeFilter(filter) {
      this.filter = filter
    },
    changePage() {
      // this.newchatnotify = {}
      this.selectedUser = null
    },
    deleteTag(index) {
      this.$store.state.livechat.filter.tags.splice(index, 1)
    },
    clearSearch() {},
    getUsersdata: function (userid) {
      var vm = this
      return new Promise((resolve, reject) => {
        var data = {
          userid: userid,
          pageid: vm.$store.state.livechat.pageid
        }

        api.getUsersdata(data, function (error, response) {
          if (error) {
            reject(error)
          }

          if (response.data) {
            resolve(response.data[0])
          } else {
            resolve(undefined)
          }
        })
      })
    },
    onEndSession: async function () {
      await this.endSession()
      this.$store.dispatch('forceLoadLastestUsers')
    },
    endSession: function () {
      let vm = this
      if (vm.selectedUser == null || vm.selectedBot == null) {
        return false
      }
      let data = {
        pageid: vm.$store.state.livechat.pageid,
        userid: vm.selectedUser.userid
      }
      return new Promise((resolve, reject) => {
        vm.$store.dispatch('loading')
        api.endSessionChat(data, function (error, response) {
          if (error) {
            vm.$store.dispatch('loading')
            reject(error)
          }
          vm.selectedUser = null
          if (response.responsecode == 400 && response.closed_ticket == false && response.reason) {
            vm.$swal.fire({
              type: 'warning',
              text: response.reason
            })
          } else {
            vm.selectedUser = null
            this.$set(this.$store.state.livechat, 'currentUser', null)
            this.$store.dispatch('updateLivechatUser', null)
          }

          vm.$store.dispatch('loading')
          resolve()
        })
      })
    },
    onOpenSession: async function () {
      await this.openSession()
      this.$store.commit('SET_LIVECHAT_TYPE', 'admin')
      var user = this.$store.state.livechat.currentUser
      user.type = this.type
      this.$store.dispatch('updateLivechatUser', user)
      this.$store.dispatch('forceLoadLastestUsers')
      this.updateRoute()
    },
    openSession: function () {
      let vm = this

      if (vm.selectedUser == null || vm.selectedBot == null) {
        return false
      }
      let data = {
        pageid: vm.$store.state.livechat.pageid,
        userid: vm.selectedUser.userid
      }
      return new Promise((resolve, reject) => {
        vm.$store.dispatch('loading')
        api.openSessionChat(data, function (error) {
          if (error) {
            vm.$store.dispatch('loading')

            reject(error)
          }

          vm.$set(vm.selectedUser, 'type', 'admin')
          vm.$set(vm.selectedUser, 'context', 'contactadmin')
          vm.$store.commit('SET_LIVECHAT_USER', vm.selectedUser)

          vm.$store.dispatch('loading')
          resolve()
        })
      })
    },
    updateRoute: function () {
      var query = { ...this.$route.query }
      query.app = this.app
      query.user = this.type

      this.$router.push({
        name: 'allinonechat',
        path: '/allinonechat',
        query: query
      })
      this.routeValue = JSON.stringify(this.$route.query)
    },
    async handleBbqFetchAllStatusColor() {
      const vm = this
      try {
        const pageId = vm.selectedBot.pageid
        vm.$store.dispatch('loading')
        const response = await api.getStatusColor(pageId)
        vm.$store.dispatch('loading')
        if (response && response.data) {
          vm.$store.state.bbqStatusColor = response.data
        } else {
          return null
        }
      } catch (error) {
        console.error(error)
      }
    }
  },
  watch: {
    selectedBot: function (newVal, oldVal) {
      if (newVal != oldVal) {
        var isCurrentUser = this.$store.state.livechat.currentUser

        if (isCurrentUser !== null && newVal.pageid !== this.$store.state.livechat.pageid) {
          this.$set(this.$store.state.livechat, 'currentUser', null)
        }
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/view/livechat/Livechat.js